<template>
	<loader v-if="!configResolved"/>
	<region-plans v-else-if="regionPlan"/>
	<customer-plans v-else/>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/components/Loader.vue'
import CustomerPlans from './CustomerPlans.vue'
import RegionPlans from './RegionPlans.vue'

export default {
	name: 'Plans',

	components: {
		Loader,
		CustomerPlans,
		RegionPlans
	},

	data: () => ({
		configResolved: false
	}),

	watch: {
		// App.vue loads the configuration too - release as soon as either response lands
		regionPlan(value) {
			if (value !== null) this.configResolved = true;
		}
	},

	computed: {
		...mapState({
			regionPlan: state => state.configurations.regionPlan
		})
	},

	created() {
		// mounting the wrong mode first would fire its requests and show an extra loader,
		// so wait until the RegionPlan configuration is known
		if (this.regionPlan !== null) {
			this.configResolved = true;
			return;
		}

		this.$store.dispatch('configurations/fetchAll').finally(() => {
			this.configResolved = true;
		})
	}
};
</script>
